module.exports = __webpack_public_path__ + "img/schedicon.6aea760b.svg";